import { platformAccess, platforms } from '@app/configurations';
import { assertArray } from '@app/core/utilities/array.utilities';
import { environment } from '@env/environment';
import {
  Account,
  AccountProvider,
  AdPlatform,
  AdPlatformType,
  HasAccountPlatform,
  Status,
} from '../models/common.models';

export function getPlatformLogo(
  data?: HasAccountPlatform | AccountProvider | AdPlatform | AdPlatformType,
  invert?: boolean,
): string | undefined {
  const platform = typeof data === 'string' ? data : data && (data.platform || data.accountPlatform);
  const platformData = platforms?.[platform];
  const logo = (invert && platformData?.logo_invert) || platformData?.logo;

  if (logo?.startsWith('http')) {
    return logo;
  } else {
    return `${environment.app.cdnURL}${logo}`;
  }
}
export function getPlatformName(data?: HasAccountPlatform | AccountProvider | AdPlatform): string | undefined {
  const platform = typeof data === 'string' ? data : data && (data.platform || data.accountPlatform);

  return environment.connectApp.accounts?.[platform];
}
export function getPlatform(
  data?: HasAccountPlatform | AccountProvider | AdPlatform | AdPlatformType,
): string | undefined {
  return typeof data === 'string' ? data : data && (data.platform || data.accountPlatform);
}

export function getPlatformStatusLogo(platform: string, status: string) {
  let extn = 'svg';
  if (platform.toLowerCase() === 'walmart') extn = 'png';
  return `${
    environment.app.cdnURL
  }assets/platform-status-logo/${platform.toLowerCase()}_${status.toLowerCase()}.${extn}`;
}

export function getStatusFromAccount(
  account?: HasAccountPlatform | AccountProvider | AdPlatform | AdPlatformType,
): Status | undefined {
  if (typeof account === 'string') {
    return;
  }

  switch (account?.platformAccessStatus) {
    case 'OK':
      return account.optimize ? 'success' : 'warning';
    case platformAccess.READ_ONLY.key:
      return account.optimize ? 'warning' : 'danger';
    default:
      return 'danger';
  }
}

export function hasAmazonAccount(account: Account[]): boolean {
  return assertArray(account).some((acc) => (acc.platform || acc.accountPlatform) === 'AMAZON');
}
